module.exports = __webpack_public_path__ + "static/media/ug.278e456e.svg";